var api = require("!../../../../../node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js");
            var content = require("!!../../../../../node_modules/mini-css-extract-plugin/dist/loader.js??ref--5-1!../../../../../node_modules/css-loader/dist/cjs.js??ref--5-2!../../../../../node_modules/sass-loader/dist/cjs.js??ref--5-3!../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--5-4!./_index.scss");

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.id, content, '']];
            }

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



module.exports = content.locals || {};